import { Mapping } from 'api/MappingsAPI';
import { FieldType } from 'modules/domains';

export const filterByFieldType = (mappings: Mapping[], fieldType: FieldType) =>
  mappings.filter((mapping) => mapping.fieldType === fieldType);
